var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatareport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "#151515",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5.5h10c1.1045695 0 2 .8954305 2 2v10c0 1.1045695-.8954305 2-2 2h-10c-1.1045695 0-2-.8954305-2-2v-10c0-1.1045695.8954305-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.5 11.435v-7.935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 11.485v-3.985"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.5 11.5v-6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatareport);
export default __webpack_public_path__ + "static/media/datareport.1dfc77acd7425fb8d6a8d484bf72447c.svg";
export { ForwardRef as ReactComponent };